<template>
  <section class="hero is-fullheight p-6">
    <div
      class="container has-background-light is-flex is-flex-direction-column is-justify-content-center is-align-items-center">
      <div>
        <img :src="logoPath" class="image logo-image" alt="logo">
      </div>
      <div v-if="showLanguageSwitcher">
        <!-- Language Switcher -->
        <div class="control mt-4">
          <div class="select is-info">
            <select v-model="selectedLanguage" @change="changeLanguage">
              <option value="en">en</option>
              <option value="pt-BR">pt-BR</option>
              <option value="pt">pt</option>
            </select>
          </div>
        </div>
      </div>
      <form @submit.prevent="doLogin" class="p-3">
        <div class="field">
          <p class="control has-icons-left has-icons-right">
            <input class="input" type="email" :placeholder="$t('General.EmailPlaceholder')" v-model="email" required>
          </p>
        </div>
        <div class="field">
          <p class="control has-icons-left">
            <input class="input" type="password" :placeholder="$t('General.PasswordPlaceholder')" v-model="password" required>
          </p>
        </div>
        <div class="field">
          <p class="control has-text-centered">
            <button class="button is-success is-fullwidth" :class="{ 'is-loading': isChecking }">
              {{ $t('General.Login') }}
            </button>
          </p>
        </div>
        <div class="field">
          <p class="control has-text-centered">
            <button class="button is-success is-fullwidth is-light" :class="{ 'is-loading': isChecking }">
              <a @click="registerCustomer">
                {{ $t('Customer.NewCustomer') }}
              </a>
            </button>
          </p>
        </div>
        <div class="field">
          <p class="control has-text-centered has-text-black">
          <a @click="goToResetPassword">{{ $t('General.ResetPassword') }}</a>
        </p>
        </div>
      </form>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";
import { Notyf } from "notyf";
import { changeLocale } from "@/main"; // Import the changeLocale function


const notyf = new Notyf()

export default defineComponent({
  name: "Login",
  data() {
    return {
      componentName: "Login",
      email: '',
      password: '',
      isChecking: false,
      selectedLanguage: process.env.APP_DEFAULT_LANGUAGE || 'en', // Default to 'en' if not set,
      logoPath: process.env.VUE_APP_LOGO_URL, // Access the Logo URL from environment variables
      envType: process.env.TYPE // Access the type of running environment from environment variables
    }
  },
  components: {},
  props: [],
  computed: {
    ...mapGetters(['getAccessType']),
    showLanguageSwitcher() {
      return this.envType !== 'prod';
    }
  },
  
  methods: {
    ...mapActions(['login']),
    
    async doLogin() {
      try {

        this.isChecking = true
        const loginData = await this.login({
          email: this.email,
          password: this.password,
        })
        
        this.isChecking = false

        this.$route.query.redirect = "/" + this.getAccessType;

        if (this.$route.query.redirect != null) {
          this.$router.push(this.$route.query.redirect)
        }
        else {
          this.$router.push('/')
        }

        /* await this.$router.push('/backend') */
      } catch (e) {
        notyf.error(this.$t('General.NotyfInvalidLogin'))
        this.isChecking = false
      }
    },

    async registerCustomer() {
      this.$router.push("/registration")
    },

    async changeLanguage(event: Event) {
      const target = event.target as HTMLSelectElement;
      if (target) {
        try {
          await changeLocale(target.value);
        } catch (error) {
          console.error('Failed to change language:', error);
        }
      }
    },
    goToResetPassword()
    {
      this.$router.push('/resetpassword');
    }
  },
  watch: {},
  mounted() {
  }
})
</script>

<style scoped>
.logo-image {
  height: 8em;
}
</style>
